import registry from "~/components/DoRegistry.js";
import moment from 'moment';

// NOTE: remember to bump JavaScript revision in staticResources.jspx (9) or
// current version may not load on all pages it's included in.

function computeCycleAndDateInfo(hotInstance, changes) {

    changes.forEach(([rowNum, prop, oldValue, newValue]) => {
        if (oldValue !== newValue) {
            if (['cycleType', 'startDate', 'cycles', 'endDate'].includes(prop)) {
                const rowData = {
                    startDate: hotInstance.getDataAtRowProp(rowNum, 'startDate'),
                    endDate: hotInstance.getDataAtRowProp(rowNum, 'endDate'),
                    cycles: hotInstance.getDataAtRowProp(rowNum, 'cycles'),
                    cycleType: hotInstance.getDataAtRowProp(rowNum, 'cycleType')
                };

                if (['cycleType', 'startDate', 'cycles'].includes(prop)) {
                    calculateEndDate(rowNum, rowData, hotInstance);
                }
                if (['cycleType', 'startDate', 'endDate'].includes(prop)) {
                    calculateCycles(rowNum, rowData, hotInstance);
                }
            }
        }
    });
}

function calculateEndDate(rowNum, rowData, hotInstance) {

    const startDate = moment(rowData.startDate, "MM/DD/YYYY");
    let calculatedEndDate = rowData.endDate;
    const numbCycles = rowData.cycles;
    const absCycles = Math.abs(numbCycles)
    const normalizedCycleType = normalizeCycleType(rowData.cycleType)
    let updatedData = [];

    if (startDate.isValid() && normalizedCycleType && numbCycles && !calculatedEndDate) {
        if (normalizedCycleType === '1 W') {
            calculatedEndDate = startDate.add(absCycles * 7, 'days');

        } else if (normalizedCycleType === '4 W') {
            calculatedEndDate = startDate.add(absCycles * 4, 'weeks');

        } else if (normalizedCycleType === 'MON') {
            // Note: if the starting month has 31 days and the following month has 30,
            // The system will add 1 extra day to the following month. So 2 months,
            // starting October 1st, means the end date will calculate to 12/1.
            // We don't want that. Old Code:
            //  calculatedEndDate = startDate.add( absCycles * startDate.daysInMonth(), 'days');

            let cyclesToAdd = absCycles;
            let calculationDate = startDate;

            while(cyclesToAdd > 0) {
                if (cyclesToAdd >= 1) {
                    calculationDate.add(1, 'months');
                    cyclesToAdd -= 1;
                } else {
                    const daysToAdd = cyclesToAdd * calculationDate.daysInMonth();
                    calculationDate.add(daysToAdd, 'days');
                    cyclesToAdd = 0;
                }
            }
            calculatedEndDate = calculationDate;

        } else if (normalizedCycleType === 'DAY') {
            let ceilCycles = Math.ceil(numbCycles);
            calculatedEndDate = startDate.add(ceilCycles, 'days');

        } else if (normalizedCycleType === 'YEA') {
            calculatedEndDate = startDate.add(absCycles * 365, 'days');

        } else if (normalizedCycleType === 'HOU') {
            //can't actually track hours currently; tracking as days -- if that changes this is wrong.
            let days = Math.ceil(numbCycles/24); //change to days and account for 'slide back'
            days = days < 0 ? 0 : days;  //don't set end date before start date
            calculatedEndDate = startDate.add(days, 'days');

        } else {
            console.log("Cycle type not supported: " + rowData.cycleType);
            return;
        }

        calculatedEndDate = calculatedEndDate.subtract(1, 'days'); // The last day is inclusive
        if (calculatedEndDate.isBefore(startDate)) {
            calculatedEndDate = startDate;
        }
        updatedData.push([rowNum, 'endDate', calculatedEndDate.format('MM/DD/YYYY')]);
    }

    if (updatedData.length > 0) {
        hotInstance.setDataAtRowProp(updatedData, "calculated");
    }
}

function calculateCycles(rowNum, rowData, hotInstance) {
    let startDate = moment.utc(rowData.startDate, "MM/DD/YYYY");
    let endDate = moment.utc(rowData.endDate, "MM/DD/YYYY");
    let calculatedNumbCycles = rowData.cycles;
    let normalizedCycleType = normalizeCycleType(rowData.cycleType)
    let updatedData = [];

    if (startDate.isValid() && endDate.isValid() && rowData.cycleType && !calculatedNumbCycles) {
        if (endDate.isSameOrAfter(startDate)) {
            let duration = moment.duration(endDate.diff(startDate));

            if (normalizedCycleType === '1 W') {
                calculatedNumbCycles = (duration.asDays() + 1) / 7;

            } else if (normalizedCycleType === '4 W') {
                calculatedNumbCycles = (duration.asDays() + 1) / 28;

            } else if (normalizedCycleType === 'MON') {
                // calculatedNumbCycles = moment.duration(endDate.add(1, 'days').diff(startDate)).asMonths();
                calculatedNumbCycles = (duration.asDays() + 1) / startDate.daysInMonth();

            } else if (normalizedCycleType === 'DAY') {
                calculatedNumbCycles = duration.asDays() + 1

            } else if (normalizedCycleType === 'YEA') {
                calculatedNumbCycles = (duration.asDays() + 1) / 365;

            } else if (normalizedCycleType === 'HOU') {
                calculatedNumbCycles = duration.asHours() + 24; // can't track hours...sending 24 hour blocks

            } else {
                console.log("Cycle type not supported: " + rowData.cycleType);
                return;
            }

            if (calculatedNumbCycles > 0) {
                updatedData.push([rowNum, 'cycles', roundToNearestQuarterNumCycles(calculatedNumbCycles)]);
            }
        }

        if (updatedData.length > 0) {
            hotInstance.setDataAtRowProp(updatedData, "calculated");
        }
    }
}

function normalizeCycleType(cycleType) {
    // Accepted validated values: (1-week) (4-week) (days) (hours) (month))
    //"normalize" the cycle type into something we might recognize.
    return cycleType ? cycleType.substring(0,3).replace('-', ' ').toUpperCase() : null;
}

function roundToNearestQuarterNumCycles(numbCycles) {
    numbCycles = Math.abs(numbCycles);

    let roundedNumbCycles = (Math.round(100 * numbCycles) / 100).toString();
    let x = roundedNumbCycles.split('.');
    x[0] = parseInt(x[0]);
    x[1] = parseFloat("." + x[1]);

    // Disabled pending approval from PM
    // if (between(x[1], .00, .24)) {
    //     return (x[0] + .00) ;
    // } else if (between(x[1], .25, .44)) {
    //     return (x[0] + .25);
    // } else if (between(x[1], .45, .74)) {
    //     return (x[0] + .50);
    // } else if (between(x[1], .75, .94)) {
    //     return (x[0] + .75)
    // } else if (between(x[1], .95, .99)) {
    //     return (x[0] + 1);
    // }

    return Math.floor(100 * numbCycles) / 100;
}

function between(x, min, max) {
    return x >= min && x <= max;
}

registry.register(__filename, computeCycleAndDateInfo);

export default computeCycleAndDateInfo;